import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { EntityUtils } from '@/common/utils/EntityUtils';
import { useCallback } from 'react';

export const IncListList = ({ polId }) => {
  const augRowsReq = useCallback(
    EntityUtils.parentFilterAugRowsReq('POL', polId),
    [polId]
  );

  return (
    <EntityList entity="INC_LIST" augRowsReq={augRowsReq} />
  );
};
